<template>
<svg viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-JiaDian1`]" width="1em" height="1em" v-bind="$attrs"><path d="M11.8126 0.275391H6.43861C5.52093 0.275391 4.77441 1.02188 4.77441 1.93959V15.9909C4.77441 16.9086 5.52091 17.6551 6.43861 17.6551H11.8126C12.7302 17.6551 13.4768 16.9086 13.4768 15.9909V1.93959C13.4768 1.0219 12.7302 0.275391 11.8126 0.275391ZM6.43861 1.38486H11.8126C12.1184 1.38486 12.3673 1.63379 12.3673 1.93959V8.47907H5.88388V1.93959C5.88388 1.63378 6.1328 1.38486 6.43861 1.38486ZM11.8126 16.5457H6.43861C6.1328 16.5457 5.88388 16.2967 5.88388 15.991V9.58852H12.3673V15.9909C12.3673 16.2967 12.1184 16.5457 11.8126 16.5457Z" :fill="useCurrentColor ? 'currentColor' : '#000'"/><rect x="5.779" y="1.444" width="6.711" height="7.114" rx="1" :fill="useCurrentColor ? 'currentColor' : '#F1DFFB'"/><path d="M6.83524 7.92297C7.14159 7.92297 7.38997 7.67459 7.38997 7.36824V6.81352C7.38997 6.50716 7.14159 6.25879 6.83524 6.25879 6.52889 6.25879 6.28052 6.50716 6.28052 6.81352V7.36824C6.2805 7.67457 6.52889 7.92297 6.83524 7.92297zM6.83524 10.1436C6.52889 10.1436 6.28052 10.3919 6.28052 10.6983V11.253C6.28052 11.5594 6.52889 11.8077 6.83524 11.8077 7.14159 11.8077 7.38997 11.5594 7.38997 11.253V10.6983C7.38997 10.3919 7.14158 10.1436 6.83524 10.1436z" :fill="useCurrentColor ? 'currentColor' : '#000'"/></svg>
</template>
<script>

export default {
  name: 'IconJiaDian1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
